import { Icon, IconProps } from 'components/Icon';

type AnimatedCheckmarkProps = Pick<
  IconProps,
  'size' | 'initialColorName' | 'opacity'
>;

// TODO: add back animation
export function AnimatedCheckmark({
  size,
  initialColorName,
  opacity,
}: AnimatedCheckmarkProps) {
  return (
    <Icon
      name="simple-check"
      size={size}
      keepColorOnLoad
      initialColorName={initialColorName}
      opacity={opacity}
    />
  );
}
